export const BOTTOM_NAV_SHEET_OFFSET_CLASS =
    "bottom-[calc(env(safe-area-inset-bottom)+var(--bottom-nav-height))]";

export const BOTTOM_NAV_CONTENT_PADDING = "pb-[var(--bottom-nav-reserve)]";

export const BOTTOM_NAV_RESERVED_HEIGHT = "h-[var(--bottom-nav-reserve)]";

export const BOTTOM_NAV_RESERVE_CANCEL =
    "max-md:-mb-[var(--bottom-nav-reserve)]";

export const BOTTOM_NAV_SLIDE_TRANSITION =
    "transition-transform duration-300 ease-sheet-rise motion-reduce:transition-none";

export type BottomNavTabId = "find" | "feed" | "saved" | "match" | "profile";

const TAB_BY_FIRST_SEGMENT = new Map<string, BottomNavTabId>([
    ["", "find"],
    ["find", "find"],
    ["discover", "feed"],
    ["saved", "saved"],
    ["match", "match"],
    ["profile", "profile"],
]);

export function activeBottomNavTab(pathname: string): BottomNavTabId | null {
    return TAB_BY_FIRST_SEGMENT.get(pathname.split("/")[1] ?? "") ?? null;
}

export function bottomNavHidesOnScroll(pathname: string): boolean {
    return activeBottomNavTab(pathname) === "find";
}
